import { useTranslation } from 'react-i18next';

const Tradutor = ({ path }) => {
  const { t, i18n } = useTranslation();

  if (!path) return '';
  if (!i18n) return '';
  if (i18n.isInitialized === false) return '';
  if (!i18n.exists(path)) return path;

  return t(path);
};

export default Tradutor;
